const SET_EXTRA = 'directOrder/SET_EXTRA';
const SET_EXTRAS = 'directOrder/SET_EXTRAS';

export default {
  // CHANGE_VALUES,

  SET_EXTRA,
  SET_EXTRAS,
};
